import React from "react";
import { Card } from "../modules/Settings/Consultants";

export function ConsultantsCardPage(props) {
  return <Card {...props} />;
}
